<template>
  <div class="header">
    <div class="flex padding-lr-100 bg-white align-center justify-between height64">
      <img class="logo" src="../../assets/images/logoText.png" alt @click="$router.push('/')">
      <div class="nav flex1 flex justify-end">
        <div class="margin-right-30">
          <span class="el-dropdown-link point" @click="$router.push({name:'workbench'})">工作台</span>
        </div>
        <div class="margin-right-10 ">
          <span class="el-dropdown-link point" @click="toPublic">
			  
            立即下单 <i class="el-icon-arrow-down el-icon-right"></i>
          </span>
          <!-- <el-dropdown>
            <span class="el-dropdown-link point">
              立即下单<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-popover placement="right" width="300" trigger="hover">
                  <el-image :src="appImage"></el-image>
                  <div slot="reference">APP下载</div>
                </el-popover>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-popover placement="right" width="300" trigger="hover" class="flex align-center justify-center">
                  <el-image :src="xcxImage"></el-image>
                  <div slot="reference">小程序下载</div>
                </el-popover>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
      </div>
      <div class="login" v-if="!$store.state.hasLogin">
        <div class="login-btn" @click="$router.push({name:'login'})">登录</div>
        <div class="register" @click="$router.push({name:'register'})">立即注册</div>
      </div>
      <div v-else>
        <user></user>
      </div>
    </div>
    <!-- <Carousel v-model="value2" autoplay   :autoplay-speed="2000"
        :dots="'none'"
        :arrow="'never'">
      <Carousel-item>
        <div class="demo-carousel">1</div>
      </Carousel-item>
      <Carousel-item>
        <div class="demo-carousel">2</div>
      </Carousel-item>
      <Carousel-item>
        <div class="demo-carousel">3</div>
      </Carousel-item>
      <Carousel-item>
        <div class="demo-carousel">4</div>
      </Carousel-item>
    </Carousel> -->

    <div @click="toMessage"
      class="bg-message flex align-center  padding-lr-30 margin-lr-100 margin-tb-20 line-theme height60 ">
      <img src="../../assets/images/dkw.png" alt="" class="block-26">
    </div>
    <el-carousel height="40px" direction="vertical" :autoplay="true"
      style="position: absolute;height:58px; left:165px;top:84px;width:80vw; padding:20px 0">
      <el-carousel-item v-for="(item, index) in messageList" :key="index">
        <div class="medium wn80 text-theme margin-left-10">{{item.title}}</div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
  import user from '../../components/user'

  export default {
    components: {
      user
    },
    data() {
      return {
        appImage: '',
        xcxImage: '',
        value2: 0, //幻灯片的索引，从 0 开始，可以使用 v-model 双向绑定数据
        messageList: []
      }
    },
    created() {
      let vm = this
      this.getInfo()
      this.getMessageList()
    },
    mounted() {

    },
    methods: {
      toPublic() {
        // console.log(global.userInfo, 'USERINFO');
        if (!global.userInfo) {
          return this.$router.push({
            name: 'login'
          })
        }else{
			this.$router.push({
			  name: 'place'
			})
		}
        
      },
      toMessage() {
        this.$router.push({
          name: 'message'
        })
      },
      getMessageList() {
        let vm = this
        this.$request('62d914b7b7161', {}).then(res => {
          console.log(res.data.data, 'message');
          vm.messageList = res.data.data.list
          console.log(vm.messageList, 'vm.messageList');
        })
      },
      getInfo() {
        this.$request('61cbbdb6af43a', {
          edition_number: '1'
        }).then(res => {
          this.appImage = res.data.data.edition.appDownload
          this.xcxImage = res.data.data.edition.wxDownload
        })
      },
      login() {
        this.$router.push({
          name: 'login'
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .bg-message {
    line-height: 60px;
    position: relative;
    background-color: rgb(254, 241, 236);
  }

  .header {
    width: 100%;
    height: 164rpx;
    min-width: 1200px;
    background-color: #f5f7f9;
    position: fixed;
    top: 0;
    z-index: 1000;



    .nav {
      display: flex;
      padding: 0 30px;

      a {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        //align-items: flex-end;
        color: #090B17;
        margin-right: 40px;
      }
    }

    .login {
      display: flex;
      align-items: center;
      cursor: pointer;

      .login-btn {
        width: 50px;
      }

      .register {
        width: 104px;
        height: 64px;
        text-align: center;
        background-color: #FB9E2F;
        font-size: 14px;
        color: #fff;
        line-height: 64px;
      }
    }

    .el-dropdown-link {
      color: #090B17;
    }

  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #FB9E2F;
    color: #FFFFFF;
  }
</style>
